export default "__VITE_ASSET__kM$WIxA4__"